// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-not-found {
  font-size: 36px;
  font-weight: bold;
  margin: 20px;
  text-align: center;
}

.return-link {
  font-size: 16px;
  text-decoration: none;
  color: #007bff;
  margin: 10px;
}

.return-link-active {
  font-weight: bold;
}

.single-product-container {
  margin-top: 5rem;
}

.product-title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px;
  text-align: center;
}

hr {
  border: 1px solid #ccc;
}

.product-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.product-card {
  width: 35vw;
  margin: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 1rem;
  background-color: #939393;
  background-image: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.3) 0%,
      transparent 100%
    ),
    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 0 0 2px rgba(0, 0, 0, 0.05);
  border: none;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  overflow: hidden;
}

.product-card img {
  max-width: 100%;
  border-radius: 15px;
}

.product-card-body {
  text-align: center;
}

.product-description {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.product-price-badge {
  background-color: #007bff;
  color: #fff;
  padding: 5px 10px;
  font-weight: bold;
}

.product-price-text {
  font-size: 1.25rem;
}

.product-price {
  font-size: 1.25rem;
}

.product-quantity-form {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-quantity-input {
  width: 100%;
  max-width: 150px;
  border: 1px solid #ccc;
  padding: 5px;
  margin-bottom: 10px;
}

.product-card-actions {
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/SingleProductView.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB;;;;;4EAK0E;EAC1E;iCAC+B;EAC/B,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".product-not-found {\n  font-size: 36px;\n  font-weight: bold;\n  margin: 20px;\n  text-align: center;\n}\n\n.return-link {\n  font-size: 16px;\n  text-decoration: none;\n  color: #007bff;\n  margin: 10px;\n}\n\n.return-link-active {\n  font-weight: bold;\n}\n\n.single-product-container {\n  margin-top: 5rem;\n}\n\n.product-title {\n  font-size: 24px;\n  font-weight: bold;\n  margin: 20px;\n  text-align: center;\n}\n\nhr {\n  border: 1px solid #ccc;\n}\n\n.product-details {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.product-card {\n  width: 35vw;\n  margin: 1rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-radius: 1rem;\n  background-color: #939393;\n  background-image: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.3) 0%,\n      transparent 100%\n    ),\n    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 0 0 2px rgba(0, 0, 0, 0.05);\n  border: none;\n  -webkit-backdrop-filter: blur(40px);\n  backdrop-filter: blur(40px);\n  overflow: hidden;\n}\n\n.product-card img {\n  max-width: 100%;\n  border-radius: 15px;\n}\n\n.product-card-body {\n  text-align: center;\n}\n\n.product-description {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.product-price-badge {\n  background-color: #007bff;\n  color: #fff;\n  padding: 5px 10px;\n  font-weight: bold;\n}\n\n.product-price-text {\n  font-size: 1.25rem;\n}\n\n.product-price {\n  font-size: 1.25rem;\n}\n\n.product-quantity-form {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.product-quantity-input {\n  width: 100%;\n  max-width: 150px;\n  border: 1px solid #ccc;\n  padding: 5px;\n  margin-bottom: 10px;\n}\n\n.product-card-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
